import script from "./CartSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./CartSummary.vue?vue&type=script&setup=true&lang=js"

import "./CartSummary.vue?vue&type=style&index=0&id=a56c5290&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a56c5290"]])

export default __exports__